import type { SVGProps } from 'react'

export const FailedTriangle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    role="img"
    aria-label="Failed triangle"
    {...props}
  >
    <path
      transform="scale(1.05)"
      fill="#D63D00"
      d="M8 0 .302 13.333h15.396zm.633 5.333-.24 3h-.787l-.24-3zM8 10.684a.612.612 0 1 1 0-1.223.612.612 0 0 1 0 1.223"
    />
  </svg>
)
